<div (mouseleave)="popover.close()">
  <div #popover="ngbPopover" [ngbPopover]="popoverRef" [autoClose]="'outside'">
    <div
      class="btn btn-icon btn-light btn-icon-muted btn-active-light btn-active-color-primary"
      [ngClass]="{
        'w-35px h-35px w-md-40px h-md-40px btn-custom': !smallVersion(),
        'w-35px h-35px w-md-35px h-md-35px': smallVersion(),
      }"
    >
      <div
        [ngClass]="{
          'w-25px h-25px w-md-25px h-md-25px': !smallVersion(),
          'w-20px h-20px w-md-20px h-md-20px': smallVersion(),
        }"
      >
        <img
          class="rounded-1"
          [src]="'/assets/flags/' + currentLang() + '.svg'"
          alt="icon-flag"
        />
      </div>
    </div>
  </div>
  <ng-template #popoverRef>
    <div
      class="popover-fix menu menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-semibold py-4 fs-base w-175px"
      data-kt-menu="true"
    >
      @for (mode of languagesData(); track mode) {
        <div class="menu-item px-3 my-0">
          <a
            class="menu-link px-3 py-2 d-flex gap-3"
            [ngClass]="{ active: currentLang() === mode.code }"
            (click)="setLang(mode.code)"
            (keyup.enter)="setLang(mode.code)"
            tabindex="0"
            role="button"
          >
            <div class="w-20px h-20px w-md-20px h-md-20px">
              <img
                class="rounded-1"
                [src]="'/assets/flags/' + mode.code + '.svg'"
                alt="icon-flag"
              />
            </div>
            <span class="menu-title">{{ mode.name | titlecase }}</span>
          </a>
        </div>
      }
    </div>
  </ng-template>
</div>
